<script setup>
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import BaseCard from "@/components/global-themed/BaseCard.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {usePyCrawlAnalytics} from "@/composables/admin/usePyCrawlAnalytics";
import PyCrawlQueueState from "@/components/admin/pycrawl/partials/PyCrawlQueueState.vue";
import PyCrawlTodayStats from "@/components/admin/pycrawl/partials/PyCrawlTodayStats.vue";
import PyCrawlLast7DaysStats from "@/components/admin/pycrawl/partials/PyCrawlLast7DaysStats.vue";
import PyCrawlRunningJobsTable from "@/components/admin/pycrawl/partials/PyCrawlRunningJobsTable.vue";
import PyCrawlQueuedJobsTable from "@/components/admin/pycrawl/partials/PyCrawlQueuedJobsTable.vue";
import PyCrawlRecentFinishedJobsTable from "@/components/admin/pycrawl/partials/PyCrawlRecentFinishedJobsTable.vue";
import PyCrawlRecentFailedJobsTable from "@/components/admin/pycrawl/partials/PyCrawlRecentFailedJobsTable.vue";
import PyCrawlRecentBlockedJobsTable from "@/components/admin/pycrawl/partials/PyCrawlRecentBlockedJobsTable.vue";

const {data, isLoading, isFetching, isError, refetch} = usePyCrawlAnalytics();
</script>

<template>
  <div class="tw-m-auto tw-max-w-default-container">
    <div class="tw-flex tw-flex-col tw-gap-6">
      <div class="tw-flex tw-justify-between tw-items-center">
        <h1 class="tw-text-4.5xl tw-text-font-primary tw-font-bold tw-font-sans">
          PyCrawl Analytics
        </h1>
        <div class="tw-flex tw-gap-3 tw-items-center">
          <DefaultButton
            :loading="isFetching"
            @click="refetch"
          >
            Refresh
          </DefaultButton>
        </div>
      </div>

      <LoadingBlock v-if="isLoading" />

      <BaseCard v-else-if="isError">
        <div class="tw-bg-white tw-rounded-lg tw-p-8 tw-text-center tw-text-red-500">
          Failed to load analytics. Is PyCrawl reachable?
        </div>
      </BaseCard>

      <template v-else-if="data">
        <PyCrawlQueueState :queue="data.queue" />
        <PyCrawlTodayStats
          :jobs="data.jobs"
          :pages="data.pages"
          :performance="data.performance"
        />
        <PyCrawlLast7DaysStats
          :jobs="data.jobs"
          :pages="data.pages"
          :performance="data.performance"
        />
        <PyCrawlRunningJobsTable :jobs="data.queue.running_jobs" />
        <PyCrawlQueuedJobsTable :jobs="data.queue.next_queued" />
        <PyCrawlRecentFinishedJobsTable :jobs="data.recent_finished_jobs" />
        <PyCrawlRecentBlockedJobsTable :jobs="data.recent_blocked_jobs" />
        <PyCrawlRecentFailedJobsTable :jobs="data.recent_failed_jobs" />
      </template>
    </div>
  </div>
</template>
